export default __webpack_public_path__ + "static/media/step5-b.096e4b60.png";